var _circle, _path, _path2, _path3, _circle2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcSmileyOkay(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 63,
    height: 61,
    viewBox: "0 0 63 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 30.9375,
    r: 30,
    fill: "#E7CB6F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6396 41.594C21.8229 41.9444 20.9804 41.6787 20.4507 41.0791C19.8179 40.3627 18.7241 40.2951 18.0077 40.9279C17.2914 41.5608 17.2237 42.6546 17.8565 43.3709C19.6346 45.3835 22.1094 45.4145 24.2951 44.9929C25.894 44.6845 27.7245 44.0522 29.5358 43.4264C30.1553 43.2124 30.7727 42.9991 31.3777 42.7999C36.4057 41.1441 41.3562 40.1486 45.7835 43.5913C46.5381 44.1781 47.6255 44.0421 48.2122 43.2875C48.799 42.5329 48.663 41.4455 47.9084 40.8587C41.9511 36.2263 35.3631 37.843 30.295 39.512C29.5475 39.7582 28.843 40.0014 28.1753 40.2319C26.454 40.8262 24.9772 41.336 23.6396 41.594Z",
    fill: "#081731"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.7692 28.6301C25.6809 28.6301 27.2307 27.0803 27.2307 25.1686C27.2307 23.2568 25.6809 21.707 23.7692 21.707C21.8574 21.707 20.3076 23.2568 20.3076 25.1686C20.3076 27.0803 21.8574 28.6301 23.7692 28.6301ZM42.2307 28.6301C44.1424 28.6301 45.6922 27.0803 45.6922 25.1686C45.6922 23.2568 44.1424 21.707 42.2307 21.707C40.3189 21.707 38.7692 23.2568 38.7692 25.1686C38.7692 27.0803 40.3189 28.6301 42.2307 28.6301Z",
    fill: "#081731"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.6519 35.9195L51.4994 3.93833",
    stroke: "#1F837E",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24.9375,
    r: 11,
    fill: "#1F837E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSmileyOkay);
export default __webpack_public_path__ + "static/media/ic-smiley-okay.ee8931e9164f9b2647a3ae83c4ee267a.svg";
export { ForwardRef as ReactComponent };